import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=24bb8397"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports